import { RemoveSingleMemberFromEntity } from "@components/remove-single-member-from-entity";
import { isGroupMember, isProjectMemberBase } from "@custom-types/member-type-guards";
import { getCompanyByIdSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { MenuItem, DeleteIcon } from "@flat-ui";
import { useState } from "react";
/**
 * Menu item that opens a remove-member confirmation dialog.
 * Handles project, group, and workspace member removal.
 * For team members, use TeamRemoveMenuButton instead.
 */
export function MemberRemoveMenuButton({
  member,
  companyId,
  subjectType,
  selectedProject,
  group,
  onMenuClose
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const selectedSdbCompany = useAppSelector(getCompanyByIdSelector(companyId));
  function closeDialog() {
    setIsDialogOpen(false);
    onMenuClose();
  }
  return <>
      <MenuItem label="Remove member" Icon={DeleteIcon} onClick={() => setIsDialogOpen(true)} />
      {isDialogOpen && renderRemoveDialog()}
    </>;

  /** Renders the remove member dialog based on the current subject type */
  function renderRemoveDialog() {
    if (selectedProject && subjectType === "project" && isProjectMemberBase(member)) {
      return <RemoveSingleMemberFromEntity companyId={companyId} member={member} entity={selectedProject} entityName="project" isOpenOnMount onClose={closeDialog} />;
    }
    if (group && subjectType === "group" && isGroupMember(member)) {
      return <RemoveSingleMemberFromEntity companyId={companyId} member={member} entity={group} entityName="group" isOpenOnMount onClose={closeDialog} />;
    }
    if (subjectType === "workspace" && selectedSdbCompany) {
      return <RemoveSingleMemberFromEntity companyId={companyId} member={member} entity={selectedSdbCompany} entityName="workspace" isOpenOnMount onClose={closeDialog} />;
    }
    return null;
  }
}